export default {
    selectTransaction: {
        dataTrackId: 'select-transaction',
        dataTrackLinkname: 'velg transaksjon',
    },
    functionalityButtons: {
        dataTrackId: 'functionality-buttons',
        dataTrackLinkname: 'kort funksjonalitetsknapper',
    },
    functionalityButtonExtraPayment: {
        dataTrackId: 'functionality-button',
        dataTrackLinkname: 'ekstra innbetaling',
    },
    functionalityButtonTransferFromCard: {
        dataTrackId: 'functionality-button',
        dataTrackLinkname: 'overfore fra kort',
    },
    functionalityLinkManageCard: {
        dataTrackId: 'functionality-link',
        dataTrackLinkname: 'administrer kortet',
    },
    functionalityLinkChangeCreditLimit: {
        dataTrackId: 'functionality-link',
        dataTrackLinkname: 'endre kredittgrense',
    },
    functionalityLinkValueProgram: {
        dataTrackId: 'functionality-link',
        dataTrackLinkname: 'verdiprogram',
    },
    availableCreditBar: {
        dataTrackId: 'available-credit-bar',
        dataTrackLinkname: 'tilgjengelig kreditt',
    },
    spentCredit: {
        dataTrackId: 'spent-credit',
        dataTrackLinkname: 'brukt kreditt',
    },
    infoCardNoMoreMovementsExist: {
        dataTrackId: 'info-card-no-more-movements-exist',
        dataTrackLinkname: 'infokort ingen flere transaksjoner finnes',
    },
    infoCardNoMovementsExist: {
        dataTrackId: 'info-card-no-movements-exist',
        dataTrackLinkname: 'infokort ingen transaksjoner finnes',
    },
    fetchTransactionsError: {
        dataTrackId: 'fetch-transactions-error',
        dataTrackLinkname: 'henting av transaksjoner feil',
    },
    movementList: {
        dataTrackId: 'movement-list',
        dataTrackLinkname: 'liste over transaksjoner',
    },
    cardBalanceTransactionList: {
        dataTrackId: 'card-balance-transaction-list',
        dataTrackLinkname: 'kortsaldo med transaksjonsliste',
    },
};
